import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { ReqBoardApplyList } from "@/types";
import { AxiosResponse } from "axios";

export default {
    async list(idx: number, param: types.ReqParam): Promise<types.ResBoardActionList> {
        const res = {} as types.ResBoardActionList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/comment/list/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async add(idx: number, param: types.ReqBoardActionCommentForAdmin): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/comment/add/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(idx: number, param: types.ReqBoardActionCommentForAdmin): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/comment/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/comment/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
